module.exports = "https://cdn.dove.it/_next/static/public/assets/agencies/sell-properties.39e2b4e3bb4559437de13c64eac1ba8d.jpg";